<mat-dialog-content class="ai-image-tips-dialog">
	<div class="dialog-header nice-scroll">
		<div class="title-row">
			<mat-icon class="title-icon">tips_and_updates</mat-icon>
			<h2 mat-dialog-title>{{ 'ai_image_tips_title' | translate }}</h2>
		</div>
		<button mat-icon-button mat-dialog-close>
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div class="tips-overview-container nice-scroll">
		<div class="tip-section main-tip full-width-tip">
			<div class="tip-sketch">
				<img
					src="assets/img/ai-tips/machineLabel.png"
					alt="{{ 'ai_image_tips_labels_title' | translate }}"
				/>
			</div>
			<div class="tip-content">
				<h3>{{ 'ai_image_tips_labels_title' | translate }}</h3>
				<p>{{ 'ai_image_tips_labels_description' | translate }}</p>
			</div>
		</div>

		<div class="secondary-tips-row">
			<div class="secondary-tip">
				<div class="tip-sketch">
					<img
						src="assets/img/ai-tips/multipleAngles.png"
						alt="{{ 'ai_image_tips_angles_title' | translate }}"
					/>
				</div>
				<div class="tip-content">
					<h3>{{ 'ai_image_tips_angles_title' | translate }}</h3>
					<p>{{ 'ai_image_tips_angles_description' | translate }}</p>
				</div>
			</div>

			<div class="secondary-tip">
				<div class="tip-sketch">
					<img
						src="assets/img/ai-tips/flashlight.png"
						alt="{{ 'ai_image_tips_lighting_title' | translate }}"
					/>
				</div>
				<div class="tip-content">
					<h3>{{ 'ai_image_tips_lighting_title' | translate }}</h3>
					<p>{{ 'ai_image_tips_lighting_description' | translate }}</p>
				</div>
			</div>
		</div>
	</div>

	<p class="ai-image-tips-dialog-footer">
		{{ 'ai_image_tips_footer' | translate }}
	</p>
</mat-dialog-content>
